module.exports = __webpack_public_path__ + "static/media/cocktails.249ed20a.jpeg";